/* Firebase Storage handle. Real client photography is uploaded here
   (admin only); the public site reads the resulting download URLs. */
import { getStorage } from 'firebase/storage'
import { app } from './firebase.js'

export const storage = getStorage(app)
